import React, { useReducer } from 'react';
import { CATEGORIES, SUBCATEGORIES } from '../../common/categories';
import OnPrem from './onPrem/OnPrem';
import NewCategory from '../../components/Category/NewCategory';
import { useSelector } from 'react-redux';
import useSearch from '../../hooks/useSearch';
import { filterFieldsBySystemMode } from '../../common/utils';
import { useTabs } from '../../hooks/useTabs';
import { fieldsReducer, initFieldsState, mapCustomInsightsToSettings, mapOwnersConfigToSettings } from './NhiReducer';
import { useSaveSettings } from '../../hooks/useSaveSettings';

const { NON_HUMAN_IDENTITIES } = CATEGORIES;
const { NHI_ON_PREM } = SUBCATEGORIES;

interface NhiSettingsProps {
    saveFunc: () => void;
    systemMode: string;
}

const NhiSettings: React.FC<NhiSettingsProps> = ({ saveFunc, systemMode }) => {
    const settings = useSelector((state: { settings: { settings: object } }) => state.settings.settings);
    const [fields, dispatch] = useReducer(fieldsReducer, { settings }, initFieldsState);

    const visibleFields = useSearch(filterFieldsBySystemMode(fields, systemMode));
    const [selectedTab, setSelectedTab] = useTabs(NON_HUMAN_IDENTITIES, visibleFields);
    const [saveCustomInsights] = useSaveSettings(
        saveFunc,
        settings,
        mapCustomInsightsToSettings,
        fields,
        selectedTab,
        dispatch
    );
    const [saveOwnersSyncConfig] = useSaveSettings(
        saveFunc,
        settings,
        mapOwnersConfigToSettings,
        fields,
        selectedTab,
        dispatch
    );

    const content =
        visibleFields[NHI_ON_PREM.ID] && selectedTab === NHI_ON_PREM.ID ? (
            <OnPrem
                saveCustomInsights={saveCustomInsights}
                saveOwnersSyncConfig={saveOwnersSyncConfig}
                dispatch={dispatch}
                fields={fields}
            />
        ) : null;

    return (
        <NewCategory
            category={NON_HUMAN_IDENTITIES}
            fields={fields}
            visibleFields={visibleFields}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}>
            {content}
        </NewCategory>
    );
};
export default NhiSettings;
